export const APPLICATION_ERROR = "APPLICATION_ERROR",
  APPLICATION_BEGIN = "APPLICATION_BEGIN",
  APPLICATION_SUCCESS = "APPLICATION_SUCCESS",
  CHANGE_STEP = "CHANGE_STEP",
  TOGGLE_DS_TYPE = "TOGGLE_DS_TYPE",
  SET_VALIDATION_ERRORS = "SET_VALIDATION_ERRORS",
  SET_DS_VARIABLES = "SET_DS_VARIABLES",
  CLEAR_STATE = "CLEAR_STATE";
